/********
  * Service: USE THIS SERVICE TO ENCRYPTION SYSTEM  - 
    #. ENCRYPT AND DECRYPT THE DATA VIA CRYPTO-JS .
    #. THIS SERVICE SECOND PURPOSE OF CENTRALIZATION THE LOCAL STORAGE THROUGHPUT THE PROJECT ....
  * @AUTHOR: IMPRESSICO(fb/nagender).
  * DATE: 08/01/2024.
  * UPDATE: --/--/----.
*/
import { Injectable, NgZone } from '@angular/core';
import * as CryptoJS from 'crypto-js';
@Injectable()
export class EncryptionService {
    private secretKey = 'djfkbg90843h5fbke8935832hf@3439854rgkj'; // Replace with a strong secret key
    public saveData(key: string, value: any) {// Store the data in local-storage
        localStorage.setItem(key, this.encrypt(value));
    }
    public getData(key: string) {// Get the data from local-storage
        let data = localStorage.getItem(key) || "";
        return data ? this.decrypt(data) : '';
    }
    public removeData(key: string) {// Remove the single data from local-storage
        localStorage.removeItem(key);
    }
    public clearData() {// Vanish all the local-storage ...mostly use during logout the user.
        localStorage.clear();
    }
    private encrypt(data: any): string { // Encrypt the data 
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
        return encryptedData;
    }
    private decrypt(encryptedData: any): any {// Decrypt the data 
        const decryptedData = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
        return JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8));
    }
}


// WEBPACK FOOTER //
// ./src/app/services/encryption.service.ts